import React, { useState, useRef, useEffect, useContext, useMemo } from 'react';
import { Modal, message } from 'antd';
import './material_card.less';
import { WorksDisplayContext } from '../../../works_display_context';
import { isVideo, toQualityImg, getQueryVariable, getZipImg2000, getZipImg300 } from '@util/utils';
import { Thumbnail } from '@components/product_item/product_item';
import Iconfont from '@components/iconfont/iconfont';
import ImageView from '@components/imageView/viewer';
import IsWhiteImg from "@components/isWhiteImg";
import tabTitleApi from "@util/tabTitleApi";
import { useTranslation } from 'react-i18next';
import { getZipImg700 } from '../../../../../util/utils';
import PrivateLangContext from "@components/private_lang_context";

export default function MaterialCard({
    material,
    materialCardStyle = {},
    showSelectBox = false,
    selectCallback,
    onMouseEnterCallback = () => { },
    onMouseLeaveCallback = () => { },
    onMouseDownCallback = () => { },
    onMouseUpCallback = () => { },
    handleEditMaterialCallback = () => { },
    handleDeleteMaterialCallback = () => { },
    goProductDetailCallback = () => { },
    isSelected = false,
    active,
    isAllowHoverActive,
    isEdit = false,
    materialIsNotClose,
    max,
    isWhite= true,
    imagesResolved = true,
    isProductDetailHandled = false
}) {
    const { clientId, roleProductPermissionsList, teamInfo, clientType, isUsedForProductDetailCase } = useContext(WorksDisplayContext)
    let _isSelected = isSelected
    let _isAllowHoverActive = isAllowHoverActive
    let _active = active
    const contentRef = useRef()
    const deleteConfirmRef = useRef()
    const [contentWidth, setContentWidth] = useState(null)
    const isDisableGoProductDetail = !isProductDetailHandled && (window.location.href.indexOf('/product_detail_share.html') != -1 || window.location.href.indexOf('/share_page.html') != -1)
    const isDisableTeamHome = window.location.href.indexOf('/team_home.html') != -1 || (window.location.href.indexOf('/team_supplier.html') != -1) 
    const { baseTabs } = tabTitleApi({ clientId: clientId })
    const productName = baseTabs?.product?.name || '产品'
    const { customT, componentLanguage } = useContext(PrivateLangContext)
    const { t:globalT, i18n } = useTranslation();
    const t = useMemo(()=>{
        if(!isEdit) return globalT;
        return customT||globalT
    },[i18n?.language,componentLanguage,isEdit]);
    useEffect(() => {
        if (!deleteConfirmRef.current) return
        deleteConfirmRef.current.update({
            title: t('提示'),
            content: t('你确定要删除吗?'),
            okText: t('确定'),
            cancelText: t('取消'),
        })
    }, [i18n?.language, componentLanguage, isEdit])
    useEffect(() => {
        if (!isEdit && deleteConfirmRef.current) {
            deleteConfirmRef.current.destroy()
            deleteConfirmRef.current = null
        }
    }, [isEdit])
    useEffect(() => {
        return () => {
            deleteConfirmRef.current?.destroy()
            deleteConfirmRef.current = null
        }
    }, [material?.id])
    const key = getQueryVariable('key')
    const goProductDetail = async () => {
        const language = !isEdit?i18n.language:componentLanguage||i18n.language
        // tabs 名称按语言取（原中英二元，日文显示中文）
        let newProductName = baseTabs?.product?.mlNickName?.[language] || (language == 'zh' ? productName : (baseTabs?.product?.enName || productName))
        const product = material
        const isAdmin = teamInfo?.role === 2 || clientType === 1
        const isShare = isAdmin || roleProductPermissionsList?.share
        const hadShare = product.status !== 5 && (isShare || isAdmin) ? 1 : 0

        if (isDisableGoProductDetail) {
            return
        }
        if(language != 'zh' && !baseTabs?.product?.mlNickName?.[language]) newProductName = 'Product'
        // let href = `/product_detail.html?type=${product?.type}&id=${product?.id}&clientId=${product?.clientId}&clientType=${product?.clientType}&hadShare=${hadShare}&showProductCase=1` + (isUsedForProductDetailCase ? `&closeBack=1` : '')
        let href = `/product_detail.html?type=${product?.type}&id=${product?.id}&clientId=${product?.clientId}&clientType=${product?.clientType}&hadShare=${hadShare}&showProductCase=1&closeBack=1`

        if (product?.discard) {
            message.info(`${newProductName}${t('已删除')}`)
            return
        }
        const pathname = window.location.pathname
        if ((!materialIsNotClose || (!isAdmin && !roleProductPermissionsList?.view && !isDisableTeamHome))&&pathname!='/international.html') {
            message.info(`${t('暂无')}${newProductName}${t('查看权限')}`)
            return
        }
        //英文版本的时候 打开内置资材页面即可

      
        if (product?.status === 3 || product?.status === 4 || product?.status === 6) {
            if (pathname==='/international.html') {
                href = `/international.html#/product_detail_share?id=${product?.id}&clientId=${product?.clientId}&tabIndex=2&fallbackLng=${i18n?.language}`;
                // window.location.href = href
                // if(window.location.href.indexOf('product_detail_share?')>=0){
                //     window.location.reload()
                // }
                
    
                // window.open(`/international.html#/product_detail_share?id=${product?.id}${key ? '&key=' + key : ""}&fallbackLng=en&isCoverEn=0`, product.id)
                // return
            }
            window.open(href, '_blank')
        } else if (product?.status === 1 || product?.status === 5) {
            message.info(`${t(newProductName)}${t('未发布')}`)
        } else {
            if (isAdmin) {

                window.open(href, '_blank')

            } else {
                message.info(`${t(newProductName)}${t('未发布')}`)
            }
        }
    }

    useEffect(() => {
        const contentElement = contentRef.current
        if (contentElement) {
            setContentWidth(contentElement.offsetWidth)
        }
    }, [material])

    const hadSkuImages = useMemo(() => {
        if (material?.productSkus?.length) {
            let arr = []
            material.productSkus.forEach(sku => {
                if (sku?.attachmentImages?.length) {
                    sku.attachmentImages.forEach(img => {
                        arr.push({ img: [img] })
                    })
                }
            })
            return arr.length > 0 ? arr : false
        }
        return false
    }, [material])

    // return material?.disabled ? <div></div> : <div
    return  <div className='works-display-panel-material-card-container-wrapper' style={
            materialCardStyle
        }>
        <div
        className={`works-display-panel-material-card-container ${_isAllowHoverActive && !_active && !showSelectBox ? 'material-card-container-hover-active' : ''} ${_active ? 'material-card-container-active' : ''} ${isDisableGoProductDetail ? 'works-display-panel-material-card-container-disable' : ''}`}
        
        onMouseEnter={e => {
            onMouseEnterCallback(e)
        }}
        onMouseLeave={() => {
            onMouseLeaveCallback()
        }}
        onMouseDown={e => {
            onMouseDownCallback(e)
        }}
        onMouseUp={e => {
            onMouseUpCallback(e)
        }}
        onClick={() => {
            goProductDetailCallback()
            if (!isProductDetailHandled) goProductDetail()
        }}
    >
        <div className='cover'>
            {(material?.covers?.[0] || material?.showContent?.showImageEntity?.url) ? (isVideo(material?.covers?.[0]) && !material?.showContent?.showImageEntity?.url ? (
                <IsWhiteImg src={material?.covers?.[0]} muted isVideo item={material?.coversV2?.[0]} />
                // <video src={material?.covers[0]} muted ></video>
            ) : (
                <Thumbnail url={material?.showContent?.showImageEntity?.url ? getZipImg300(material?.showContent?.showImageEntity) : material?.covers?.[0]} item={material?.coversV2?.[0]} isWhiteShow={material?.showContent?.showImageEntity ? material?.showContent?.showImageEntity?.color?.isPureColor > 0 : material?.coversV2?.[0]?.isPureColor > 0} isWhite />
            )) : <img src='https://app-test.zjhzoyad.com/zip-9e50aae3-1b8a-4212-833d-a8ca2210c9efad1d4e10-0e46-43df-b519-9bc5b515e5bcdefault_bg.png' />}
            {
                showSelectBox && <div className='mask' onClick={e => {
                    e.stopPropagation()
                    if (showSelectBox) {
                        selectCallback(material?.id)
                    }
                }}></div>
            }

            {
                showSelectBox && <div className={`select-box select-box-hover  ${_isSelected ? 'selected' : ''}`}>
                    {_isSelected &&
                        <Iconfont className='icon' type='icon-dui-20' />}
                </div>
            }
        </div>
        <div className='content' ref={contentRef}>
            <div className='name oneline'>{material?.name}</div>
            {
                (contentWidth && hadSkuImages)
                    ? <ColorImagesWidget containerWidth={contentWidth} colorImages={hadSkuImages} max={max} />
                    : (imagesResolved ? <div className='sized-box'>{t('暂无高清贴图')} </div> : <div className='sized-box'></div>)
            }
            {/* {
                material?.reference_price && material?.reference_price?.start ? <div className='price'><span className>¥</span><span>{material?.reference_price.start}～{material?.reference_price.end}元/{material?.priceUnit}</span><span>参考价</span></div> : <div></div>
            } */}
        </div>
        {
            !isDisableGoProductDetail && <div className='works-display-panel-arrow-container'>
                <div className={`arrow ${_isAllowHoverActive && !_active && !showSelectBox ? 'material-card-container-arrow-hover-active' : ''} ${_active ? 'material-card-container-arrow-active' : ''} ${showSelectBox ? 'arrow-active-none' : ''}`}>
                    <Iconfont className='icon' type={isWhite?'icon-a-danjiantouxiangyou-changtaise':'icon-houtui-baise-zuo1-copy-copy'} />
                </div>
            </div>
        }
        {
            isEdit && <div className='mask' onClick={e => {
                    e.stopPropagation()
                    if (showSelectBox) {
                        selectCallback(material?.id)
                    }
                }}></div>
        }
        </div>
        {
            isEdit &&!showSelectBox && <div className='function-container'>
                <div className='edit-button-mask'></div>
                <div className='edit-button-text' onClick={(e) => {
                    handleEditMaterialCallback()
                    e.stopPropagation()
                }}>
                    {/* <Iconfont className='icon' type='icon-a-bianji-202' /> */}
                    {t('编辑')}
                </div>
                <div className='edit-button-text' onClick={(e) => {
                    e.stopPropagation()
                    deleteConfirmRef.current = Modal.confirm({
                        className: 'works-confirm-model',
                        zIndex: 1051,
                        title: t('提示'),
                        content: t('你确定要删除吗?'),
                        okText: t('确定'),
                        cancelText: t('取消'),
                        closable: true,
                        onOk: () => {
                            deleteConfirmRef.current = null
                            handleDeleteMaterialCallback()
                        },
                        onCancel: () => {
                            deleteConfirmRef.current = null
                        },
                    })
                }}>
                    {/* <Iconfont className='icon' type='icon-a-shanchu-203' /> */}
                   {t('删除')}
                </div>
            </div>
        }
    </div>
}

function ColorImagesWidget({
    containerWidth,
    colorImages,
    max
}) {
    const [showColorImages, setShowColorImages] = useState([])
    const [isImageView, setIsImageView] = useState(false)
    const [initImageIndex, setInitImageIndex] = useState(0)
    let maxNumber = max || Math.floor((containerWidth - 40) / 50)
    useEffect(() => {
        if (colorImages.length > maxNumber) {
            setShowColorImages([...colorImages.slice(0, maxNumber)])
        } else {
            setShowColorImages([...colorImages])
        }
    }, [colorImages])

    return <div className='works-display-panel-material-color-image-container'>
        {
            showColorImages?.map((item, index) => {
                return <div className='img-container' key={index}>
                    <img key={index} src={getZipImg300(item?.img[0])} alt=''
                        onClick={e => {
                            setInitImageIndex(index)
                            setIsImageView(true)
                            e.stopPropagation()
                        }}
                        onError={e => e.target.src = item?.img[0]?.url}
                    />
                    {
                        (colorImages.length > maxNumber && (index === (showColorImages.length - 1))) && <div className='color-mask'></div>
                    }
                    {
                        (colorImages.length > maxNumber && (index === (showColorImages.length - 1))) && <div className='more-tip'>+{colorImages.length - (maxNumber - 1)}</div>
                    }
                </div>
            })
        }
        {
            isImageView &&
            <ImageView
                list={colorImages}
                urlFilter={(item) => {
                    return getZipImg2000(item?.img[0])
                }}
                currentInx={initImageIndex}
                infos={<div>test</div>}
                leftSytle={{
                    background: 'white',
                }}
                close={() => {
                    setIsImageView(false)
                }}
                isView={isImageView}
                showWorksDisplayName={true}
            ></ImageView>
        }
    </div>
}
